import { render } from "./DocPage.vue?vue&type=template&id=68576b76"
import script from "./DocPage.vue?vue&type=script&lang=js"
export * from "./DocPage.vue?vue&type=script&lang=js"

import "./DocPage.vue?vue&type=style&index=0&id=68576b76&lang=css"

import exportComponent from "/codebuild/output/src2646400178/src/twilio-clone/docs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__